import { Navigate, Route, Routes, BrowserRouter, Outlet } from "react-router-dom";
import * as P from "./pages";
import { Layout, SreenCoverLoading } from "./components";
import { useAuth } from "./hooks";
export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/kakao-load" element={<P.KakaoLoad />} />

        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<Navigate to="/year-booking" />} />
          <Route element={<Layout.SimpleLayout />}>
            <Route path="/year-booking/group-register" element={<P.YearGroupRegister />} />
            <Route path="/year-booking/group-join" element={<P.GroupJoin />} />
            <Route path="/year-booking/booking-register" element={<P.YearBookingRegister />} />
            <Route path="/year-booking/group-manage" element={<P.YearGroupManage />} />
            <Route path="/year-booking/group-members" element={<P.YearGroupMemebers />} />
            <Route path="/year-booking/deposit" element={<P.Deposit />} />
            <Route path="/year-booking/condition" element={<P.YearBookingCondition />} />
            <Route path="/year-booking/proposals" element={<P.Proposals />} />
            <Route path="/year-booking/faq" element={<P.FAQ faqType="year" />} />
            <Route path="/year-booking/lan" element={<P.Landing />} />
            <Route path="/year-booking/roundPayment" element={<P.RoundPayments />} />
            <Route path="/year-booking/cancellation-policy" element={<P.CancellationPolicy />} />
            <Route path="/year-booking/privacy-consent" element={<P.PrivacyConsent />} />
            <Route path="/kgController" element={<P.KgController />} />
            <Route
              path="/year-booking/booking-register/result"
              element={<P.YearBookingRegisterResult />}
            />
            <Route
              path="/year-booking/group-members/register-all"
              element={<P.YearGroupMembersRegisterAll />}
            />
            <Route path="/year-booking/group-members/list" element={<P.YearGroupMembersList />} />
            <Route path="/year-booking/team-register" element={<P.YearGroupTeamRegister />} />
            <Route path="/year-booking/complete" element={<P.CompletePage />} />
            {/* ------------------------------- */}
            {/* ------------------------------- */}
            <Route path="/event-booking/booking-register" element={<P.EventBookingRegister />} />
            <Route path="/event-booking/application-info" element={<P.EventBookingRegister />} />
            <Route path="/event-booking/round-date" element={<P.EventBookingRegister />} />
            <Route path="/event-booking/round-options" element={<P.EventBookingRegister />} />
            <Route path="/event-booking/payment-options" element={<P.EventBookingRegister />} />
            <Route path="/event-booking/proposals" element={<P.EventProposals />} />

            <Route path="/event-booking/faq" element={<P.FAQ faqType="event" />} />
            <Route path="/event-booking/condition" element={<P.EventBookingCondition />} />
            <Route
              path="/event-booking/register-result"
              element={<P.EventBookingRegisterResult />}
            />
            <Route path="/event-booking/member-list" element={<P.EventMembersList />} />
            <Route path="/event-booking/team-register" element={<P.EventBookingTeamRegister />} />
            <Route path="/event-booking/payment" element={<P.EventPayments />} />
            <Route path="/event-booking/complete" element={<P.CompletePage />} />
          </Route>
          <Route element={<Layout.MainLayout serviceCotegory="event" />}>
            <Route path="/event-booking" element={<P.EventBooking />} />
          </Route>
          <Route element={<Layout.MainLayout serviceCotegory="year" />}>
            {/* <Route
              path="/year-booking/booking-register/result"
              element={<P.YearGroupRegisterResult />}
            /> */}
            {/* <Route element={<Layout.TopTabLayout />}> */}
            <Route path="/year-booking" element={<P.YearBooking />} />
            {/* </Route> */}

            {/* <Route path="*" element={<Navigate to="/" />} /> */}
          </Route>
        </Route>
        <Route path="/my" element={<P.My />} />
        <Route path="/loadApp/:groupCode" element={<P.LoadApp />} />
      </Routes>
    </BrowserRouter>
  );
}

const PrivateRoutes = () => {
  const { isLoading: isAuthLoading, user, isInvalidUser } = useAuth();

  // return  <SreenCoverLoading />

  if (isAuthLoading) {
    return (
      <>
        <SreenCoverLoading />
      </>
    );
  }
  if (isInvalidUser) {
    // window.location.href = "http://app.dev.teeshot.co.kr/login?redirect=" + window.location.href+"&join=sbs";
    window.location.href = `${process.env.REACT_APP_WEB_URL}/login?join=sbs`;
    // return <>유저정보 없음</>;
  }
  return <Outlet />;
};
